// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"tc_a bie_rc bie_qx bie_xr","ContestPosts__more":"tc_b bie_vu bie_b bie_va bie_sv"};